import { render, staticRenderFns } from "./DishCard.vue?vue&type=template&id=653d2252&scoped=true"
import script from "./DishCard.vue?vue&type=script&lang=js"
export * from "./DishCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d2252",
  null
  
)

export default component.exports